module.exports = __webpack_public_path__ + "thigh.c5dee66c.png";


//////////////////
// WEBPACK FOOTER
// /var/www/build-lk-1/src/components/profile/imgs/thigh.png
// module id = 1924
// module chunks = 0